import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const FlashError: React.FC<Props> = ({ children, className }) => (
  <div
    className={clsx('mb-[30px] flex flex-col mt-2.5 text-lg font-medium leading-5', className)}
    data-test-flash-message="error"
  >
    <div
      className={clsx(
        'py-3 px-6 rounded bg-[#DAE4EF] text-[#000000b3] mx-auto max-w-[600px]',
        'self-center text-center whitespace-pre-line border-[3px] border-solid',
        'border-[#B3090F] bg-[#E9DAD9]',
      )}
    >
      {children}
    </div>
  </div>
);

export default observer(FlashError);
